import React, { useState, useRef, useEffect } from "react";
import {
  back,
  forward,
  close,
  emb1,
  emb2,
  emb3,
  emb4,
  emb5,
  emb6,
  emb7,
  emb8,
  emb9,
  emb10,
  emb11,
  emb12,
  emb1big,
  emb2big,
  emb3big,
  emb4big,
  emb5big,
  emb6big,
  emb7big,
  emb8big,
  emb9big,
  emb10big,
  emb11big,
  emb12big,
} from "../../images/";

const PhotoGrid = () => {
  const images = [
    {
      name: "emb1",
      src: emb1,
      alt: "Example of Embroidery",
      bigSrc: emb1big,
    },
    {
      name: "emb2",
      src: emb2,
      alt: "Example of Embroidery",
      bigSrc: emb2big,
    },
    {
      name: "emb3",
      src: emb3,
      alt: "Example of Embroidery",
      bigSrc: emb3big,
    },
    {
      name: "emb4",
      src: emb4,
      alt: "Example of Embroidery",
      bigSrc: emb4big,
    },
    {
      name: "emb5",
      src: emb5,
      alt: "Example of Embroidery",
      bigSrc: emb5big,
    },
    {
      name: "emb6",
      src: emb6,
      alt: "Example of Embroidery",
      bigSrc: emb6big,
    },
    {
      name: "emb7",
      src: emb7,
      alt: "Example of Embroidery",
      bigSrc: emb7big,
    },
    {
      name: "emb8",
      src: emb8,
      alt: "Example of Embroidery",
      bigSrc: emb8big,
    },
    {
      name: "emb9",
      src: emb9,
      alt: "Example of Embroidery",
      bigSrc: emb9big,
    },
    {
      name: "emb10",
      src: emb10,
      alt: "Example of Embroidery",
      bigSrc: emb10big,
    },
    {
      name: "emb11",
      src: emb11,
      alt: "Example of Embroidery",
      bigSrc: emb11big,
    },
    {
      name: "emb12",
      src: emb12,
      alt: "Example of Embroidery",
      bigSrc: emb12big,
    },
  ];

  const [selectedImage, setSelectedImage] = useState(null);
  const [index, setIndex] = useState(0);
  const backdropRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (backdropRef.current && !backdropRef.current.contains(event.target)) {
        setSelectedImage(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClick = (image) => {
    setSelectedImage(image);
    setIndex(images.indexOf(image));
  };
  const handlSelectedClick = (e) => {
    const rect = e.target.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const imageWidth = rect.width;

    const clickRatio = clickX / imageWidth;

    if (clickRatio > 0.5) {
      handleNext();
    } else {
      handlePrev();
    }
  };

  const closeModal = () => {
    setSelectedImage(null);
    setIndex(0);
  };

  const handlePrev = () => {
    if (index === 0) {
      setSelectedImage(images[images.length - 1]);
      setIndex(images.length - 1);
    } else {
      setSelectedImage(images[index - 1]);
      setIndex(index - 1);
    }
  };

  const handleNext = () => {
    if (index === images.length - 1) {
      setSelectedImage(images[0]);
      setIndex(0);
    } else {
      setSelectedImage(images[index + 1]);
      setIndex(index + 1);
    }
  };

  return (
    <div className="bg-primary/70">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-5 p-4 mx-auto max-w-screen-xl">
        {images.map((image, index) => (
          <div key={index}>
            <img
              className="h-[200px] w-[45vw] xl:h-[300px] object-cover rounded-lg cursor-pointer hover:shadow-2xl hover:scale-110 hover:shadow-xl transition duration-400 ease-in-out"
              src={image.src}
              alt={image.alt}
              onClick={() => handleClick(image)}
            />
          </div>
        ))}
        {selectedImage && (
          <div className="fixed inset-0 z-50 bg-black bg-opacity-70 flex justify-center items-center">
            <div
              ref={backdropRef}
              className="max-w-[90dvw] max-h-[90dvh] mx-auto relative"
            >
              <button
                className="absolute top-2 right-2 bg-white/70 rounded-full w-[45px] h-[45px] text-center text-xl   text-white"
                onClick={closeModal}
              >
                <img className="w-full h-full p-3" src={close} alt="close" />
              </button>
              <img
                className="max-w-[90dvw] max-h-[90dvh] mx-auto"
                src={selectedImage.bigSrc}
                alt={selectedImage.alt}
                onClick={(e) => handlSelectedClick(e)}
              />
              <button
                className="absolute top-1/2 transform -translate-y-1/2 left-2 bg-black/50 rounded-full w-[35px] h-[35px] xl:w-[50px] xl:h-[50px]  text-white"
                onClick={handlePrev}
              >
                <img
                  className="w-full h-full p-2 xl:p-3"
                  src={back}
                  alt="back"
                />
              </button>
              <button
                className="absolute top-1/2 transform -translate-y-1/2 right-2 bg-black/50 rounded-full w-[35px] h-[35px] xl:w-[50px] xl:h-[50px] text-white"
                onClick={handleNext}
              >
                <img
                  className="w-full h-full p-2 xl:p-3 "
                  src={forward}
                  alt="next"
                />
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PhotoGrid;

// const PhotoGrid = ({ imageList }) => {
//   return (
//     <section className="bg-primary mx-auto">
//       <div className=" mx-auto sm:w-[80%] ">
//         <div className="p-6 ">
//           <h1 className="text-black text-3xl sm:text-5xl font-bold  pb-4 h-1/5 flex items-center justify-center">
//             Examples
//           </h1>
//         </div>
//         <div class="flex p-3 flex-wrap justify-center">
//           {" "}
//           {Object.values(imageList).map((img) => (
//             <div class="h-auto  w-1/2 md:w-1/4  md:m-4  sm:w-[200px] rounded-lg">
//               <img
//                 class="w-[150px] md:w-[300px] "
//                 loading="lazy"
//                 src={img}
//                 alt=""
//               />
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default PhotoGrid;
